<div class="container">
    <div class="card">
        <div class="title">
            <mat-icon color="accent" class="title-icon">description</mat-icon>
            <h2>Certification Requirements</h2>
        </div>
        <div class="divider"></div>
        <p class="description">
            Review the detailed requirements for each Alabama Educator Certification pathway.
            Select a document below to learn about the qualifications and criteria for your chosen approach.
        </p>

        <div *ngIf="loading" class="text-center py-4">
            <mat-spinner diameter="40" class="m-auto"></mat-spinner>
        </div>

        <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

        <mat-nav-list class="pdf-list" *ngIf="!loading && !error">
            <a mat-list-item *ngFor="let item of summaryFiles" (click)="openFile(item)" class="pdf-item cursor-pointer">
                <mat-icon matListItemIcon color="accent">picture_as_pdf</mat-icon>
                <span matListItemTitle>{{item.displayName}}</span>
                <span matListItemMeta class="code-badge">{{item.approach}}</span>
            </a>
        </mat-nav-list>
    </div>
</div>